import { Injectable } from '@angular/core';
import { IpoFetchService } from '@ip-only/front-end-library';
import Keycloak from 'keycloak-js';
import { BehaviorSubject } from 'rxjs';
import {
  KeycloakUser,
  LoggedInUser,
  SelfserviceGroupAdminRoles,
} from '../../hub/entities/user';
import { setHubUserCookie } from '../../keycloak/keycloak-cookie';
import { UserApiService } from './user-api.service';

@Injectable({ providedIn: 'root' })
export class UserService extends IpoFetchService<KeycloakUser, UserApiService> {
  private portalUser$ = new BehaviorSubject<LoggedInUser | undefined>(
    undefined
  );

  constructor(api: UserApiService, private keycloak: Keycloak) {
    super(api);
  }

  public setPortalUser(portalUser: LoggedInUser) {
    this.portalUser$.next(portalUser);
  }

  public getPortalUser$() {
    return this.portalUser$.asObservable();
  }

  public isPortalUser(): boolean {
    return !!this.portalUser$.getValue();
  }

  public isCustomerServiceAgent(): boolean {
    return !!this.portalUser$.getValue()?.customerServiceAgent;
  }

  public isUserAdmin(): boolean {
    const adminRoles: string[] = Object.values(SelfserviceGroupAdminRoles);
    const userRoles = this.portalUser$.getValue()?.roles;
    return userRoles
      ? userRoles.some((role) => adminRoles.includes(role))
      : false;
  }

  public initializeUser(user: LoggedInUser) {
    this.setPortalUser(user);
    setHubUserCookie(true);
  }

  public logout(redirectUri?: string): Promise<void> {
    setHubUserCookie(false);

    return new Promise((resolve, reject) => {
      this.keycloak
        .logout({
          redirectUri,
        })
        .then(() => {
          resolve();
        })
        .catch(() => reject('An error occured during Keycloak logout.'));
    });
  }
}
